import {
  DocumentReference,
  ISoftDelete,
  Region,
} from '@principle-theorem/shared';
import { IOrganisation } from '../organisation/organisation';
import { IUser } from '../user/user';

export enum PartnerTestAccountStatus {
  Active = 'active',
  Provisioning = 'provisioning',
  Failed = 'failed',
}

export const PARTNER_TEST_ACCOUNT_STATUS_MAP: {
  [key in PartnerTestAccountStatus]: string;
} = {
  [PartnerTestAccountStatus.Active]: 'primary',
  [PartnerTestAccountStatus.Provisioning]: 'default',
  [PartnerTestAccountStatus.Failed]: 'warn',
};

export interface IPartnerTestAccount extends ISoftDelete {
  name: string;
  status: PartnerTestAccountStatus;
  region: Region;
  seedFileName: string;
  userRef: DocumentReference<IUser>;
  organisationRef?: DocumentReference<IOrganisation>;
}
